import type { GroupAccess } from "@soundsgoodas/sg-common";
import { OPSMATE_PROFILE_BASE } from "../services/api";
import { Button } from "./Button";

interface GroupCardProps {
  groupId: string;
  group: GroupAccess;
}

const STATUS_STYLES: Record<string, string> = {
  active: "bg-emerald-100 text-emerald-800",
  inactive: "bg-red-100 text-red-800",
  pending: "bg-amber-100 text-amber-800",
};

export function GroupCard({ groupId, group }: GroupCardProps) {
  function handleClick() {
    if (typeof Missive !== "undefined") {
      Missive.openURL(`${OPSMATE_PROFILE_BASE}/groups/${groupId}`);
    }
  }

  return (
    <Button
      variant="secondary"
      className="rounded-md border border-(--border-color,#e5e7eb) bg-(--card-background,#f9fafb) p-3 text-left transition-colors hover:border-(--accent-color,#3b82f6) hover:opacity-100"
      onClick={handleClick}
    >
      <p className="mb-1 text-sm font-medium text-(--text-color,#111)">
        {group.group_name || "Unnamed Group"}
      </p>
      <div className="flex items-center gap-2">
        <span className="text-xs capitalize text-(--text-muted,#6b7280)">
          {group.role || "member"}
        </span>
        <span
          className={`rounded-full px-1.5 py-px text-[0.625rem] font-medium capitalize ${
            STATUS_STYLES[group.status ?? ""] ?? "bg-amber-100 text-amber-800"
          }`}
        >
          {group.status || "unknown"}
        </span>
      </div>
    </Button>
  );
}
